import { createSelector } from 'reselect';

const adminSelector = state => state.admin;

// USERS
export const users = createSelector(adminSelector, state => state.users);
export const userOptions = createSelector(adminSelector, state => state.userOptions);
export const userMap = createSelector(adminSelector, state => state.userMap);
export const currentAdminUser = createSelector(adminSelector, state => state.currentUser);
export const currentAdminGroup = createSelector(adminSelector, state => state.currentGroup);
export const currentAdminGroupId = createSelector(adminSelector, state => state.currentGroupId);

// PROPERTIES
export const properties = createSelector(adminSelector, state => state.properties);

// ROLES
export const adminRoles = createSelector(adminSelector, state => state.roles);

// GROUPS
export const adminGroups = createSelector(adminSelector, state => state.groups);
export const currentGroup = createSelector(adminSelector, state => state.currentGroup);

// SITES
export const sites = createSelector(adminSelector, state => state.sites);
export const cultureMapSiteOptions = createSelector(adminSelector, state => state.cultureMapSitesOptions);
export const cultureMapSiteOptionsBasic = createSelector(adminSelector, state => state.cultureMapSitesOptionsBasic);
export const siteOptions = createSelector(adminSelector, state =>
  state.sites.map(site => ({
    key: site.id,
    value: site.id,
    text: site.name,
  }))
);
export const siteOptionsDetail = createSelector(adminSelector, state => state.sitesOptionsDetail);

const isMapSite = s => !s.text.toLowerCase().includes('map');
export const cultureMapSites = createSelector(adminSelector, state => state.sitesOptionsDetail?.filter(isMapSite));
export const dallasId = createSelector(
  adminSelector,
  state => state.sitesOptionsDetail?.find(s => s.text.toLowerCase().includes('dallas')).key
);
export const cityOptions = createSelector(adminSelector, state => state.citiesOptions);
export const currentSite = createSelector(adminSelector, state => state.currentSite);

// EMAIL TEMPLATES
export const emailTemplates = createSelector(adminSelector, state => state.emailTemplates);
export const currentEmailTemplate = createSelector(adminSelector, state => state.currentEmailTemplate);

export const cultureMapCities = createSelector(adminSelector, state => {
  const cities = ['Austin', 'Dallas', 'Fort Worth', 'Houston', 'San Antonio'];
  console.log(state.sitesOptions);
  const options = state.sitesOptions.filter(s => cities.includes(s.text));
  return [...options, { key: '', text: 'All', value: '' }];
});

export const allProperties = createSelector(adminSelector, state => {
  const cities = ['Austin', 'Dallas', 'Fort Worth', 'Houston', 'San Antonio', 'InnovationMap', 'EnergyCapital','SportsMap'];
  const options = state.sitesOptions.filter(s => cities.includes(s.text));
  return [...options, { key: '', text: 'All', value: '' }];
});
